import { tryGetProp } from '../global.functions';
import { ControlType, ControlTypeInfo, isContainerControl } from './control.interface';
import {
    BarcodeScanner,
    FileBrowserControl,
    CalculationControl,
    CheckboxControl,
    CheckboxGroupControl,
    ComboControl,
    CreditcardControl,
    DateControl,
    DocGenControl,
    GeoLocationControl,
    GroupControl,
    HeadingControl,
    HiddenControl,
    HtmlControl,
    iApplyFormControl,
    LabelControl,
    LikertControl,
    PhotoboothControl,
    RadioControl,
    RepeaterControl,
    SearchControl,
    SignaturePadControl,
    SummaryControl,
    TextControl,
    TimepickerControl,
    TwoFactorVerificationControl,
    CybersourceControl,
    DigitalIdControl,
} from './control.model';
import _ from 'lodash';

export class ControlFactory
{
    /** Create an array of iApplyFormControl from a JSON data array. */
    static createControlList(data?: any): iApplyFormControl[]
    {
        let result = [];
        if (data) {
            data.forEach(item => {
                // console.log(item);
                let control = ControlFactory.createControl(item);
                result.push(control);
            });
        }

        return result;
    }

    /** Create a single iApplyFormControl (and children*) from the JSON data provided. */
    static createControl(data?: any): iApplyFormControl {
        let control = null;
        const type = tryGetProp(data, 'Type');

        switch (type) {
            // Calculation = "calculation",
            case ControlType.Calculation:
                control = new CalculationControl();
                break;

            // case ControlType.Text:
            //     return new TextControl(data);
            //     break;

            // Checkbox = "checkbox",
            case ControlType.Checkbox:
                control = new CheckboxControl();
                break;

            // Checkboxgroup = "checkboxgroup",
            case ControlType.Checkboxgroup:
                control = new CheckboxGroupControl();
                break;

            // Combo = "combo",
            case ControlType.Combo:
                control = new ComboControl();
                break;

            // Cybersource payment control
            case ControlType.Cybersource:
                control = new CybersourceControl();
                break;

            // Datepicker = "datepicker",
            case ControlType.Datepicker:
                control = new DateControl();
                break;

            // Filebrowser = "filebrowser",
            case ControlType.Filebrowser:
                control = new FileBrowserControl();
                break;

            // Geolocation = "geolocation",
            case ControlType.Geolocation:
                control = new GeoLocationControl();
                break;

            // Group = "group",
            case ControlType.Group:
                control = new GroupControl();
                break;

            // Heading = "heading",
            case ControlType.Heading:
                control = new HeadingControl();
                break;

            // Hidden = "hidden",
            case ControlType.Hidden:
                control = new HiddenControl();
                break;

            // Html = "html",
            case ControlType.Html:
                control = new HtmlControl();
                break;

            // Label = "label",
            case ControlType.Label:
                control = new LabelControl();
                break;

            // Likert = "likert",
            case ControlType.Likert:
                control = new LikertControl();
                break;

            // Radio = "radio",
            case ControlType.Radio:
                control = new RadioControl();
                break;

            // Repeater = "repeater",
            case ControlType.Repeater:
                control = new RepeaterControl();
                break;

            // Search = "search",
            case ControlType.Search:
                control = new SearchControl();
                break;

            // Signaturepad = "signaturepad",
            case ControlType.Signaturepad:
                control = new SignaturePadControl();
                break;

            // Summary = "summary",
            case ControlType.Summary:
                control = new SummaryControl();
                break;

            // Text = "text",
            case ControlType.Text:
                control = new TextControl();
                break;

            // Timepicker = "timepicker",
            case ControlType.Timepicker:
                control = new TimepickerControl();
                break;

            // Creditcard = "creditcard",
            case ControlType.Creditcard:
                control = new CreditcardControl();
                break;

            // Photobooth = "photobooth",
            case ControlType.Photobooth:
                control = new PhotoboothControl();
                break;

            // Docgen = "docgen",
            case ControlType.Docgen:
                control = new DocGenControl();
                break;

            // Twofactorverification = "twofactorverification",
            case ControlType.Twofactorverification:
                control = new TwoFactorVerificationControl();
                break;

            // Barcodescanner = "barcodescanner",
            case ControlType.Barcodescanner:
                control = new BarcodeScanner();
                break;

            case ControlType.DigitalId:
                control = new DigitalIdControl();
                break;

            // Unknown = "Unknown",
            default:
                // throwError(() => new Error("Unknown control type: " + type));
                control = new iApplyFormControl();
                break;
        }

        control.init(data);
        control.typeName = ControlFactory.controlTypeNameFromValue(type);
        return control;
    }

    static controlTypeNameFromValue(type: string): string {
        const controlType = _.find(ControlTypeInfo, { controltype: type });
        return controlType?.title;
    }

    static sortControls(controls: iApplyFormControl[]) {
        controls.forEach((control, index) => {
            control.sortPosition = index;
            if (isContainerControl(control)) {
                ControlFactory.sortControls(control.controls);
            }
        });
    }
}
